import { Component, input, InputSignal, model, ModelSignal, inject } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';
import { DataAnalyticsService } from '../../services/data-analytics/data-analytics.service';

export type ExpandIconType = 'circle' | 'arrow';
export type ExpandPanelBackgroundColour = 'clear' | 'white' | 'grey' | 'tint';

@Component({
  selector: 'td-wb-expandable-panel',
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss'],
  imports: [ IconComponent ]
})
export class ExpandablePanelComponent {
  private readonly dataAnalyticsService = inject(DataAnalyticsService);

  readonly size: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly noPadding: InputSignal<boolean | undefined> = input<boolean | undefined>(undefined);
  readonly isInline: InputSignal<boolean> = input<boolean>(false);
  readonly hasDivider: InputSignal<boolean | undefined> = input<boolean | undefined>(undefined);
  readonly isExtended: InputSignal<boolean | undefined> = input<boolean | undefined>(undefined);
  readonly iconType: InputSignal<'caret' | ExpandIconType> = input<'caret' | ExpandIconType>('circle');
  readonly panelBackgroundColour: InputSignal<ExpandPanelBackgroundColour> = input<ExpandPanelBackgroundColour>('clear');
  readonly iconColour: InputSignal<'primary' | 'primary2' | 'inverse' | 'secondary'> = input<'primary' | 'primary2' | 'inverse' | 'secondary'>('primary');
  readonly iconExpanded: ModelSignal<boolean> = model<boolean>(false);
  readonly taggingEventName: InputSignal<string | undefined> = input<string | undefined>(undefined);

  getToggleIconId(): string {
    const iconType = this.iconType();
    if (iconType === 'circle') {
      return this.iconExpanded() ? 'collapse' : 'expand';
    } else if (iconType === 'caret') {
      return this.iconExpanded() ? 'caret--up' : 'caret--down';
    } else {
      return this.iconExpanded() ? 'caret-up--small' : 'caret-down--small';
    }
  }

  toggleIcon(): false {
    this.iconExpanded.set(!this.iconExpanded());
    if (this.iconExpanded() && this.taggingEventName()) {
      this.dataAnalyticsService.emitLinkClickEvent(this.taggingEventName());
    }
    return false;
  }
}
